export const chevronEdge = `
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18"><g fill="#222"><path d="M1 0a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1 1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Z" data-name="Path 3"/><path d="M14 0a1 1 0 0 1 .707 1.707L7.414 9l7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8A1 1 0 0 1 14 0Z" data-name="Path 2"/></g></svg>
`
